
import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";

import ConsultaBMSI from '../../../../lib/json/consultas/BMSI.json'
import ConsultaCC from '../../../../lib/json/consultas/CentroCustoSelect.json'

import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import SubmitForm from "../../../components/SubmitForm";
import { converteDataProtheus, ErroMsg, formatarComoMoeda, formatarMoeda2, parseLocaleNumber, RetornaUsuarioLogado, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import { ConsultaTotvsEmpresa } from "../../../../backend/ConsultaTotvsEmpresa";
import SelectContaContabil from "../../../components/Select/ContaContabil";
import SelectDinamico from "../../../components/SelectDinamico";
import SelectCentroCusto from "../../../components/Select/CentroCusto";
import { HRDivider } from "../../SSMA/FichaGiroSSMA/styles";
import SelectFixoTotvs from "../../../components/SelectFixoTotvs";
import { CancelarButton } from "../../../components/SubmitForm/styles";
import ResponsiveDataTable from "../../../components/DataTable";
import { ConsumoAPI_FileUpload } from "../../../../backend/ConsumoAPI";
import UploadFiles from "../../../components/UploadFiles";
import { LabelInput } from "../../../components/InputGeral/styles";
import { format } from "date-fns";
import { toBeVisible } from "@testing-library/jest-dom/matchers";
import { CelBreak25 } from "../../../components/GridCell/styles";

function FichaBMSI(){
    const navigate = useNavigate();
    const currentDate = new Date()
    const isFormVisual = window.location.href.includes('Visualizar');

    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus
    const parametroEmpresa = usuarioLogado.filtraParametroEmpresasCentroCusto
    
    let filtraCentroCusto = ''

    if (parametroEmpresa.centroCusto.length > 0 ){
        filtraCentroCusto += " AND CTT_CUSTO IN ('" + parametroEmpresa.centroCusto.join("','") + "')"
    }

    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);
    const [disabledFormCab, setDisabledFormCab] = useState(false);
    const [disabledCC, setDisabledCC] = useState(false);

    const { idBMSI, empresaFilialBMSI } = useParams();
    
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState(empresaFilialBMSI);
    const [empresaFilial, setEmpresaFilial] = useState(empresaFilialBMSI);
    const [consultaCentroCusto, setConsultaCentroCusto] = useState("");

    // Consulta do grid
    var consultaDefault  = ConsultaBMSI.consulta
    const cConsultaTipo  = "SELECT PZ1.*, CTT_DESC01, CTT_XTIPO FROM TABELA(PZ1) PZ1 LEFT JOIN TABELA(CTT) CTT ON CTT_CUSTO = PZ1_CONTAB AND CTT.D_E_L_E_T_ <> '*' WHERE PZ1.D_E_L_E_T_ <> '*' ORDER BY PZ1_ID"
    const cTabelaTipo  = "PZ1;CTT"
    const cConsulta  = "SELECT MIN(CTT_CUSTO) CTT_CUSTO, CTT_DESC01, CTT_XTIPO FROM TABELA(CTT) WHERE CTT_CLASSE = '2' AND CTT_BLOQ = '2' AND D_E_L_E_T_ <> '*' AND CTT_FILIAL = FILIAL(CTT) " + filtraCentroCusto + " GROUP BY CTT_DESC01, CTT_XTIPO"
    const cTabelas  = "CTT"

    const [campoCodigo, setCampoCodigo]       = useState('0');
    const [campoTipoBMSI, setCampoTipoBMSI] = useState({value: '', label: 'Selecione o Tipo de BMSI'});
    const [campoCentroCusto, setCampoCentroCusto] = useState({value: '', label: 'Selecione o Centro de Custo'});
    const [contasContabeis, setContasContabeis] = useState({value: '', label: 'Selecione o Centro de Custo'});
    const [campoContaContabil, setCampoContaContabil] = useState();
    const [campoDataEmissao, setCampoDataEmissao] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [campoDataCompetenciaInicio, setCampoDataCompetenciaInicio] = useState();
    const [campoDataCompetenciaFinal, setCampoDataCompetenciaFinal] = useState();
    const [campoAnexos, setCampoAnexos] = useState([]);
    const [campoTotalBMSI, setCampoTotalBMSI] = useState(0);
    
    const [campoIdItem, setCampoIdItem] = useState('');
    const [campoEmpresa, setCampoEmpresa] = useState({value: '', text: 'Selecione a Empresa/Filial'});
    const [campoCentroCustoItem, setCampoCentroCustoItem] = useState({value: '', label: 'Selecione o Centro de Custo'});
    const [campoContaContabilItem, setCampoContaContabilItem] = useState();
    const [tipoCentroCustoItem, setTipoCentroCustoItem] = useState('');
    const [campoQuantidade, setCampoQuantidade] = useState();
    const [campoValorUnitario, setCampoValorUnitario] = useState();
    const [campoValorTotal, setCampoValorTotal] = useState();
    const [campoDetalhe, setCampoDetalhe] = useState('');
    const [dataItem, setDataItem] = useState([]);
    const [dataGridItem, setDataGridItem] = useState([]);
    
    const empresas = JSON.parse(localStorage.getItem('empresasOptions'));    

    const columnsItem = [
        {
            Header: 'Empresa/Filial',
            accessor: 'campoEmpresa.value',
        },
        {
            Header: 'Centro de Custo Débito',
            accessor: 'campoCentroCustoItem.label',
            Cell: (item) => {
                return <>
                    <p><strong>C.Custo: </strong>{item.value}</p>
                    <p><strong>Conta: </strong>{item.row.original.contaContabilLabel}</p>
                    <CelBreak25><strong>Detalhe: </strong>{item.row.original.campoDetalhe.trim()}</CelBreak25>
                </>
            }
        },
        {
            Header: 'Quantidade',
            accessor: "campoQuantidade",
        },
        {
            Header: 'Valor Unitário',
            accessor: 'campoValorUnitario',
        },
        {
            Header: 'Valor Total',
            accessor: "campoValorTotal",
        },
        {
            Header: 'Status',
            accessor: 'status',
        }
    ];

    useEffect(() => {
        if (idBMSI){
            loadBMSI();
        }
    }, []);

    // Processa consulta do grid
    const loadBMSI = async () => {
        setCarregar(true);
        
        consultaDefault = consultaDefault.replace("CAMPOS", `, CTT.CTT_XTIPO, CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),PZ2_ANEXOS))) AS PZ2_ANEXOS,
            CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),PZ2_OBS))) PZ2_OBS,
            PZ2_STATUS, PZ2_CONTAB, PZ2_CTBZIC, PZ2_ITEM, PZ2_EMPITC, PZ2_CCDEBI, PZ2_CONTDE, PZ2_QTD, PZ2_VUNITA, PZ2_VTOTAL, PZ2_APRCRE,
            PZ1_CCCRED, PZ1_CCCDIC, PZ1_CCDEBI, PZ1_CCDBIC,
            (SELECT M0_CODIGO + M0_CODFIL + ' - ' + M0_FILIAL FROM SYS_COMPANY WHERE M0_CODIGO + M0_CODFIL = PZ2_EMPITC AND D_E_L_E_T_ <> '*') EMPITC, 
            (SELECT CT1A.CT1_DESC01 FROM TABELA(CT1) CT1A WHERE CT1A.CT1_CONTA = PZ2_CONTDE  AND CT1A.D_E_L_E_T_ <> '*') CTADEB, 
            (SELECT CTTA.CTT_DESC01 FROM TABELA(CTT) CTTA WHERE CTTA.CTT_FILIAL = LEFT(RIGHT(LTRIM(RTRIM(PZ2_EMPITC)), 6), 4) AND CTTA.CTT_CUSTO = PZ2_CCDEBI AND CTTA.D_E_L_E_T_ <> '*') DEBITO, 
            (SELECT CTTA.CTT_XTIPO FROM TABELA(CTT) CTTA WHERE CTTA.CTT_FILIAL = LEFT(RIGHT(LTRIM(RTRIM(PZ2_EMPITC)), 6), 4) AND CTTA.CTT_CUSTO = PZ2_CCDEBI AND CTTA.D_E_L_E_T_ <> '*') TIPOCC `)
        consultaDefault = consultaDefault.replace("FILTRO", ` AND PZ2_FILIAL = FILIAL(PZ2) AND PZ2_ID = '${idBMSI}' ORDER BY PZ2_ID, PZ2_ITEM`)
        
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaBMSI.tabelas, empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) );

        let aItens = []
        if (retConsulta.data){
            const { CTT_XTIPO, PZ1_CCCRED, PZ1_CCCDIC, PZ1_CCDEBI, PZ1_CCDBIC } = retConsulta.data[0]
            const overHead = {Credito: PZ1_CCCRED, Debito: PZ1_CCDEBI}
            const operacional = {Credito: PZ1_CCCDIC, Debito: PZ1_CCDBIC}
            
            try {                
                setCampoAnexos( JSON.parse(retConsulta.data[0].PZ2_ANEXOS.trim() || '[]'))
            } catch (error) {
                setCampoAnexos( JSON.parse('[]'))
            }
            
            setContasContabeis( { overHead, operacional})
            setCampoCodigo(retConsulta.data[0].PZ2_ID);
            setCampoDataEmissao(converteDataProtheus(retConsulta.data[0].PZ2_DTINCL));
            setCampoCentroCusto({value: retConsulta.data[0].PZ2_CCCRED, label: retConsulta.data[0].PZ2_CCCRED + ' - ' + retConsulta.data[0].CTT_DESC01})
            setCampoContaContabil({value: retConsulta.data[0].PZ2_CONTAD.trim(), label: retConsulta.data[0].PZ2_CONTAD + ' - ' + retConsulta.data[0].CT1_DESC01 })
            setCampoDataCompetenciaInicio(converteDataProtheus(retConsulta.data[0].PZ2_PCOINI));
            setCampoDataCompetenciaFinal(converteDataProtheus(retConsulta.data[0].PZ2_PCOFIM));
            setCampoTipoBMSI({value: retConsulta.data[0].PZ2_SERVIC, label: retConsulta.data[0].PZ2_SERVIC + ' - ' + retConsulta.data[0].PZ1_DESCRI, origem: {CTT_DESC01: retConsulta.data[0].PZ2_CCCRED,
                CTT_XTIPO: CTT_XTIPO,
                PZ1_CCCDIC: PZ1_CCCDIC,
                PZ1_CCCRED: PZ1_CCCRED,
                PZ1_CCDBIC: PZ1_CCDBIC,
                PZ1_CCDEBI: PZ1_CCDEBI,
                PZ1_DESCRI: retConsulta.data[0].PZ1_DESCRI,
                PZ1_ID: retConsulta.data[0].PZ2_SERVIC,
                PZ1_CONTAB: retConsulta.data[0].PZ2_CCCRED
            }})

            setDisabledFormCab(true)

            retConsulta.data.map((item) => {
                let cStatus = ""
                const {PZ2_STATUS, PZ2_CONTAB } = item;

                switch (PZ2_STATUS) {
                    case "P":
                        cStatus = "Em Aprovação";
                        break;                
                    case "A":
                        cStatus = ((PZ2_CONTAB == 'S') ? "Contabilizado" : "Aprovado");
                        break; 
                    case "R":
                        cStatus = "Reprovado";
                        break; 
                    default:
                        cStatus = "Elaboração";
                        break;
                }

                aItens.push({
                    Id: item.PZ2_ID + item.PZ2_ITEM, 
                    item: item.PZ2_ITEM,
                    campoEmpresa: {value: item.PZ2_EMPITC, text: item.EMPITC},
                    campoCentroCustoItem: {value: item.PZ2_CCDEBI, label: item.PZ2_CCDEBI + ' - ' + item.DEBITO}, 
                    tipoCentroCustoItem: item.TIPOCC,
                    contaContabilDebito: item.PZ2_CONTDE,
                    contaContabilLabel: item.PZ2_CONTDE + ' - ' + item.CTADEB,
                    campoQuantidade: formatarMoeda2(parseFloat(item.PZ2_QTD), 2),
                    campoValorUnitario: formatarMoeda2(parseFloat(item.PZ2_VUNITA), 4),
                    campoValorTotal: formatarMoeda2(parseFloat(item.PZ2_VTOTAL), 2),
                    campoDetalhe: item.PZ2_OBS,
                    status: cStatus,
                    deletado: false
                })
            })

            setDataItem(aItens)
        }
        
        setCarregar(false);
    }

    const handleSalvar = async() =>{
        let cJSON = ''
        const oJSON = dataItem.map((item) => {
            item.ACAO = idBMSI ? 'ALTERAR' : 'INCLUIR';            
            item.Id = campoCodigo
            item.Tipo = campoTipoBMSI
            item.Emissao = campoDataEmissao
            item.CC = campoCentroCusto
            item.Conta = campoContaContabil.value
            item.Inicio = campoDataCompetenciaInicio
            item.Fim = campoDataCompetenciaFinal
            item.Usuario = usuarioProtheus.value
            item.Anexo = campoAnexos ? JSON.stringify(campoAnexos) : ""

            return item
        })

        if (oJSON.length > 0){
            cJSON = JSON.stringify(oJSON)
        }
        
        setCarregar(true);
        const oRetorno = await ConsumoTOTVS_POST('BMSI', cJSON, empresaFilial)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
            return false;
        }

        return true;
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    const handleCampoCentroCustoItem = (e) => {
        setDisabledCC(true)
        if (e?.origem) {
            const { CTT_XTIPO } = e?.origem

            setCampoCentroCustoItem({ value: e.value, label: e.label })
            setTipoCentroCustoItem(CTT_XTIPO.trim())

            const Conta = CTT_XTIPO.trim() === "2" ? contasContabeis.operacional.Debito : contasContabeis.overHead.Debito
            setCampoContaContabilItem({value: Conta.trim(), label: '' })
        }else{
            setCampoCentroCustoItem({value: '', label: 'Selecione o Centro de Custo'})
            setTipoCentroCustoItem('')
            setCampoContaContabilItem()
        }
    }

    const handleCampoQuantidade = (e, valor) => {
        const inputValue = valor;
        
        if (/^(?:\d{1,3}(?:\.\d{3})*)(?:\,\d{0,4})?$/.test(inputValue) || inputValue === '') {
            const valorTotal = parseLocaleNumber(inputValue) * parseLocaleNumber(campoValorUnitario || '0,00')
    
            setCampoQuantidade(inputValue)
            setCampoValorTotal(formatarMoeda2(valorTotal,2))
        }
    }

    const handleCampoValorUnitario = (e, valor) => {
        const inputValue = valor;
        
        // Validate if the input is a valid number with up to 6 decimals
        if (/^(?:\d{1,3}(?:\.\d{3})*)(?:\,\d{0,4})?$/.test(inputValue) || inputValue === '') {
            const valorTotal = parseLocaleNumber(inputValue) * parseLocaleNumber(campoQuantidade || '0,00')

            setCampoValorUnitario(inputValue);
            setCampoValorTotal(formatarMoeda2(valorTotal,2));
        }
    }

    const btnIncluirItem = () => {
        if (!campoEmpresa.value && !campoEmpresa?.text.trim()){
            toast.warning('A Seleção da Empresa/Filial do Item é obrigatoria.');
            return;
        }
        if (!campoCentroCustoItem.value && !campoCentroCustoItem?.label.trim()){
            toast.warning('A Seleção do Centro de Custo do Item é obrigatório.');
            return;
        }
        if (!campoQuantidade){
            toast.warning('O prenchimento da Quantidade do Item é obrigatório.');
            return;
        }
        if (!campoValorUnitario){
            toast.warning('O prenchimento do Valor Unitário do Item é obrigatório.');
            return;
        }
        if (!campoDetalhe){
            toast.warning('O prenchimento do campo Detalhe do Item é obrigatório.');
            return;
        }
        
        if (campoIdItem){
            const id = campoIdItem
            
            setDataItem((prevData) => {
                return prevData.map((item) => {
                    if (item.item === id){
                        return { ...item, 
                                campoEmpresa: campoEmpresa, 
                                campoCentroCustoItem: campoCentroCustoItem, 
                                tipoCentroCustoItem: tipoCentroCustoItem,
                                contaContabilDebito: campoContaContabilItem.value,
                                contaContabilLabel: campoContaContabilItem.label,
                                campoQuantidade: campoQuantidade,
                                campoValorUnitario: campoValorUnitario,
                                campoValorTotal: campoValorTotal,
                                campoDetalhe: campoDetalhe,
                                status: 'Elaboração',
                                deletado: false
                            };
                    }else{
                        return item;
                    } 
                })
            });

            setCampoIdItem('')
        }else{
            const newId = Date.now()
            const dataLastItem = dataItem.findLast( (item) => item.item )
            const lastItem = parseFloat( dataLastItem ? dataLastItem.item : '0')
            const item = String(lastItem + 1)
                
            setDataItem((prevData) => [...prevData, { 
                Id: newId, 
                item: item.padStart(4, '0'),
                campoEmpresa, 
                campoCentroCustoItem, 
                tipoCentroCustoItem,
                contaContabilDebito: campoContaContabilItem.value,
                contaContabilLabel: campoContaContabilItem.label,
                campoQuantidade,
                campoValorUnitario,
                campoValorTotal,
                campoDetalhe,
                status: 'Elaboração',
                deletado: false
            },]);
        }

        btnCancelarItem()
    };

    const btnCancelarItem = () => {
        setCampoIdItem('')
        setCampoEmpresa( {value: '', text: 'Selecione a Empresa/Filial'} )
        setCampoCentroCustoItem( {value: '', label: 'Selecione o Centro de Custo'} )
        setTipoCentroCustoItem('')
        setCampoQuantidade('')
        setCampoValorUnitario('')
        setCampoValorTotal('')
        setCampoDetalhe('')
        setCampoContaContabilItem('')
    }

    const handleAlterarItem = (row) => {
        setCampoIdItem( row.original.item )
        setCampoEmpresa( row.original.campoEmpresa )
        setCampoCentroCustoItem( row.original.campoCentroCustoItem )
        setTipoCentroCustoItem( row.original.tipoCentroCustoItem )
        setCampoQuantidade( row.original.campoQuantidade )
        setCampoValorUnitario( row.original.campoValorUnitario )
        setCampoValorTotal( row.values.campoValorTotal )
        setCampoDetalhe( row.original.campoDetalhe )
        setCampoContaContabilItem({value: row.original.contaContabilDebito.trim(), label: '' })
    };

    const handleExcluirItem = (row) => {
        const id = row.original.item;

        setDataItem((prevData) => 
            prevData.map((item) => {
                if (item.item === id){
                    return { ...item, deletado: true };
                }else{
                    return item;
                } 
            })
        );
    };

    useEffect(() => {
        const total = dataItem.reduce((total, item) => {
            const valor = Number(parseLocaleNumber(item.campoValorTotal) || 0);
            return total + valor;
        }, 0)
        setCampoTotalBMSI(formatarComoMoeda(Number(total.toFixed(2))));
        
        setDataGridItem(dataItem.filter((item) => !item.deletado));
    }, [dataItem]);

    const handleAddFiles = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];

        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC, TXT, planilhas do Excel ou arquivos CSV.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexos, ...newFiles]
            setCampoAnexos(filesUpload)

            return filesUpload;
        }
    }

    const handleDelFiles = (fileDelete) => {
        const updatedFiles = [...campoAnexos];
        updatedFiles.splice(fileDelete, 1);

        setCampoAnexos(updatedFiles)
        return updatedFiles;
    }


    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text="BMSI" 
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial &&
                <>
                    <Row>
                        <Col md="2" xs="12">
                            <InputGeral 
                                label="Código"
                                tipo='text'
                                value={campoCodigo}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoCodigo(e.target.value)}
                                disabled={!idBMSI || disabledFormCab }                    
                            />
                        </Col>
                        <Col md="7" xs="12">
                            <SelectDinamico
                                campoValue={campoTipoBMSI}
                                onchange={(e) => {
                                    setCampoTipoBMSI(e);
                                    
                                    if (e?.origem){
                                        const { PZ1_CONTAB, CTT_DESC01, CTT_XTIPO, PZ1_CCCRED, PZ1_CCDEBI, PZ1_CCCDIC, PZ1_CCDBIC} = e.origem
                                        if (PZ1_CONTAB && PZ1_CONTAB.trim()){
                                            setDisabledCC(true)
                                            setCampoCentroCusto({value: PZ1_CONTAB, label: PZ1_CONTAB + ' - ' + CTT_DESC01 })
                                        }

                                        const overHead = {Credito: PZ1_CCCRED, Debito: PZ1_CCDEBI}
                                        const operacional = {Credito: PZ1_CCCDIC, Debito: PZ1_CCDBIC}
                                        const Conta = CTT_XTIPO.trim() === '2' ? operacional.Credito : overHead.Credito

                                        setCampoContaContabil( {value: Conta.trim(), label: ''} )
                                        setContasContabeis( { overHead, operacional})
                                    }else{
                                        setDisabledCC(isFormVisual ? true: false)
                                        setCampoCentroCusto({value: '', label: 'Selecione o Centro de Custo'})
                                        setCampoContaContabil()
                                        setContasContabeis()
                                    }
                                }}
                                EmpresaLogada={empresaFilial}
                                cText={"PZ1_ID + ' - ' + item.PZ1_DESCRI"}
                                cValue={"PZ1_ID"}
                                consulta={cConsultaTipo}
                                tabela={cTabelaTipo}
                                returnOrigem={true}
                                showNoFilter={true}
                                label={"Tipo do BMSI"}
                                placeholder={"Selecione Tipo do BMSI"}
                                disabled={disabledFormCab}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <InputGeral
                                label="Data de Emissão"
                                placeholder="Data de Emissão"
                                tipo="date"
                                value={campoDataEmissao}
                                onChange={(e) => setCampoDataEmissao(e.target.value)}
                                disabled={true}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectDinamico
                                campoValue={campoCentroCusto}
                                onchange={(e) => {
                                    setCampoCentroCusto(e)

                                    if (e?.origem){
                                        const { overHead, operacional } = contasContabeis
                                        const Conta = e.origem.CTT_XTIPO.trim() === '2' ? operacional.Credito : overHead.Credito
                                        
                                        setCampoContaContabil( {value: Conta.trim(), label: ''} )
                                    }
                                    if (!(e?.value.trim())){
                                        setDisabledCC(isFormVisual ? true: false)
                                    }
                                }}
                                EmpresaLogada={empresaFilial}
                                cText={"CTT_CUSTO  + ' - ' + item.CTT_DESC01"}
                                cValue={"CTT_CUSTO"}
                                consulta={cConsulta}
                                tabela={cTabelas}
                                label={"Centro de Custo Crédito"}
                                placeholder={"Selecione o Centro de Custo"}
                                disabled={disabledCC}
                                returnOrigem={true}
                            />
                        </Col>
                        <Col md="4" xs="12">
                            <SelectContaContabil
                                valueTrim={true} 
                                empresaLogada={empresaFilial}
                                label="Conta Contábil Crédito"
                                campoContaContabil={campoContaContabil}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoContaContabil}
                                disabled={true}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Competência Inicial"
                                placeholder="Data Competência Inicial"
                                tipo="date"
                                value={campoDataCompetenciaInicio}
                                onChange={(e) => setCampoDataCompetenciaInicio(e.target.value)}
                                disabled={disabledFormCab}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Competência Final"
                                placeholder="Data Competência Final"
                                tipo="date"
                                value={campoDataCompetenciaFinal}
                                onChange={(e) => setCampoDataCompetenciaFinal(e.target.value)}
                                disabled={disabledFormCab}
                            />
                        </Col>
                    </Row>                    
                    <Row>
                        <Col md="12" xs="12">
                            <LabelInput>Anexo</LabelInput>
                            <UploadFiles 
                                onDropEvent={handleAddFiles}
                                onDeleteEvent={handleDelFiles}
                                value={campoAnexos}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <HRDivider></HRDivider>
                    <Row>
                        <Col md="10" xs="12">
                            <h5>Itens do BMSI (Débito): </h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col md='2'>
                            <SelectFixoTotvs 
                                options={empresas}
                                value={campoEmpresa}
                                selectedOptionValue={campoEmpresa}
                                isLabel={true} 
                                label="Empresa/Filial" 
                                disabled={disabledForm}
                                onChange={(e) => {
                                    let cConsultaCC = ''
                                    setCampoEmpresa(e)
                                    setDisabledCC(true)

                                    if (e?.value.trim()){
                                        cConsultaCC = ConsultaCC.consulta + " WHERE CTT.D_E_L_E_T_ <> '*' AND CTT_CLASSE = 2 AND CTT_BLOQ = 2  AND CTT_FILIAL = '" + e.value.substr(2,4) + "'"
                                    }

                                    setConsultaCentroCusto(cConsultaCC)
                                }}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectCentroCusto
                                label="Centro de Custo"
                                campoCentroCusto={campoCentroCustoItem}
                                changeCentroCusto={handleCampoCentroCustoItem}
                                empresaLogada={empresaFilial}
                                queryCentroCusto={consultaCentroCusto}
                                loadDefault={true}
                                returnOriginal={true}
                                disabled={disabledForm}
                                filtraFilial={true}
                                filtraUserCC={false}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Quantidade"
                                placeholder="Quantidade"
                                tipo="monetario"
                                value={campoQuantidade}
                                onChange={handleCampoQuantidade}
                                disabled={disabledForm}
                                decimal={2}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Valor Unitário"
                                placeholder="Valor Unitário"
                                tipo="monetario"
                                value={campoValorUnitario}
                                onChange={handleCampoValorUnitario}
                                disabled={disabledForm}
                                decimal={4}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <InputGeral
                                label="Valor Total"
                                placeholder="Valor Total"
                                tipo="monetario"
                                value={campoValorTotal}
                                onChange={setCampoValorTotal}
                                disabled={true}
                                decimal={2}
                            />
                        </Col>
                        <Col md="6" xs="12" style={{display: "none"}}>
                            <SelectContaContabil
                                valueTrim={true} 
                                empresaLogada={empresaFilial}
                                label="Crédito"
                                campoContaContabil={campoContaContabilItem}  // Define o valor do campo com base no estado
                                changeContaContabil={setCampoContaContabilItem}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="12" xs="12">
                            <InputGeral
                                label="Detalhe"
                                placeholder="Detalhe"
                                tipo='text'
                                value={campoDetalhe}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoDetalhe(e.target.value)}
                                disabled={disabledForm }
                            />
                        </Col>
                    </Row>
                        { !disabledForm && (
                            <Row className="d-flex align-content-end align-items-end justify-content-end">
                                <Col md="3" xs="12" >
                                    <Button style={{width: "100%"}} variant="primary" onClick={btnIncluirItem}>
                                        { campoIdItem && "✓ Salvar" || "✚ Adicionar" }
                                    </Button>
                                </Col>
                                { campoIdItem && (
                                    <Col md="3" xs="12" >
                                        <CancelarButton style={{width: "100%"}} variant="warning" onClick={btnCancelarItem}>
                                            ✗ Cancelar
                                        </CancelarButton>
                                    </Col>
                                )}
                            </Row>
                        )}
                    {dataItem && (
                        <>
                            <ResponsiveDataTable 
                                habilitaBuscar={false} 
                                columns={columnsItem} 
                                data={dataGridItem} 
                                isIgnorar={true}
                                buttons= { disabledForm
                                    ? []
                                    : [
                                        {action: handleAlterarItem, label: "Alterar", icone: "MdOutlineEditNote", regraExclude: "('Contabilizado|Aprovado').split('|').includes(row.values.status)"}, 
                                        {action: handleExcluirItem, label: "Excluir", icone: "MdPlaylistRemove", style: "danger", regraExclude: "('Contabilizado|Aprovado').split('|').includes(row.values.status)"},
                                    ]
                                }
                            />
                            <Row>
                                <Col md="9" xs="12"></Col>
                                <Col md="3" xs="12">
                                    <InputGeral
                                        label="Total Nota Fiscal"
                                        placeholder="Total Nota Fiscal"
                                        tipo="monetario"
                                        value={campoTotalBMSI}
                                        disabled={true}
                                        onChange={(e) => setCampoTotalBMSI(e)}
                                        decimal={2}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                </>
            }
            
            { dataGridItem && dataGridItem.length > 0 &&
                <SubmitForm 
                    onSave={ disabledForm ? null : handleSalvar}
                    onCancel={ disabledForm ? null : "handleCancelar"}
                    onVoltar={ disabledForm ? "handleVoltar" : null}
                />
            }
        </>
    );
}

export default FichaBMSI;